import algoliaSearch from 'algoliasearch';
export function AlgoliaSearch(_ref) {
  let {
    applicationId,
    apiKey,
    indexName,
    query,
    facetFilters,
    after,
    first
  } = _ref;
  const client = algoliaSearch(applicationId, apiKey);
  return client.search([{
    indexName,
    query,
    params: {
      hitsPerPage: first,
      page: Math.floor(after / first),
      facetFilters
    }
  }]);
}